import { Component } from '@angular/core';
import { NavController, LoadingController, ToastController } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../../../../../globals';
import { ConfigurationServices } from '../../../services';
import { ConfigurationPrintersWizardListPage } from '../configuration-printers-wizard-list/configuration-printers-wizard-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'page-configuration-printers-wizard-type',
  templateUrl: 'configuration-printers-wizard-type.html'
})

export class ConfigurationPrintersWizardTypePage {

  type: any;

  constructor(public navCtrl: NavController,
    public globals: Globals,
    public http: HttpClient,
    public loadingCtrl: LoadingController,
    private configurationServices: ConfigurationServices,
    public translate: TranslateService,
    private toastCtrl: ToastController) {


  }

  select(type) {

    if (type == 'native') {
      this.type = type;
    }

    if (type == 'mpop') {
      this.type = type;
    }

    if (type == 'print_services') {
      this.type = type;
    }

    if (type == 'sunmi') {
      this.type = type;
    }

  }

  selected() {
    this.type = "";
  }

  checkState(type) {
    if (this.type == type) {
      return true
    } else {
      return false
    }
  }

  nextPage() {
    this.navCtrl.push(ConfigurationPrintersWizardListPage);
  }

  finish() {
    if (this.type) {
      let loadingPopup = this.loadingCtrl.create({
        spinner: 'crescent',
        content: this.translate.instant('instant-anadiendo')
      });
      loadingPopup.present();
      this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        'printer_type': this.type,
        'printer_cashdrawer': false,
      }).then(doc => {
        this.globals.restaurant.printer_type = this.type;
        this.globals.restaurant.printer_cashdrawer = false;
        //
        loadingPopup.dismiss();
        this.navCtrl.pop();
      }).catch(error => {
        loadingPopup.dismiss();
      })
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-selecciona-tipo-servicio-impresion'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-thermal-printers/configuration-printers-wizard/configuration-printers-wizard-type/configuration-printers-wizard-type.ts